import React from 'react';
import CardTitle from "../../ui/card/CardTitle";
import Stack from "../../ui/Stack";
import {camelToTitle} from "../../Utility";
import TableDetailList from "./TableDetailList";

const TableDetail = ({data, columns = {}, direction = "column", showTitles = false, inline = false}) => {
    const columnClass = `col-12${columns?.md ? ` col-md-${columns.md}` : ''}${columns?.lg ? ` col-lg-${columns.lg}` : ''}${columns?.xl ? ` col-xl-${columns.xl}` : ''}${columns?.xxl ? ` col-xl-${columns.xxl}` : ''}`;

    console.log(data);
    const renderValue = (value) => {
        if (React.isValidElement(value)) {
            return value;
        }
        if (typeof value === 'object' && value !== null) {
            try {
                return JSON.stringify(value, null, 2);
            } catch (e) {
                return '[Unserializable object]';
            }
        }
        return value;
    };

    return (
        <Stack className={`flex-column flex-xxxl-${direction} gap-4`}>
            {Object.keys(data).map((sectionKey) => (
                <div className="col" key={sectionKey}>
                    {showTitles && <CardTitle className="mb-4" title={camelToTitle(sectionKey)}/>}
                    <div className="row gx-5">
                        {Object.keys(data[sectionKey]).map((key) => (
                            <div className={columnClass} key={key}>
                                <TableDetailList
                                    inline={inline}
                                    title={camelToTitle(key)}
                                    value={renderValue(data[sectionKey][key])}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </Stack>
    );
};

export default TableDetail;
